import React from "react";
import useLink from "@qpr/client-api-base/hooks/useLink";

import LinkIcon from "@material-ui/icons/Link";
import { IconButton } from "@material-ui/core";
import typeToView from "routing/typetoview";
import { ICardElementWithChildren } from "backend/model/model";

const ElementLink = (
  props: React.PropsWithChildren<{ item?: ICardElementWithChildren }>
) => {
  const { item } = props;
  const link = useLink();

  if (!item) return null;

  return (
    <IconButton
      onClick={() => {
        link({
          meaId: item.id,
          page: typeToView(item.typename),
          period:
            item.workflowState?.period ||
            item.workflowInstance?.period ||
            item.period?.name,
        });
      }}
    >
      <LinkIcon />
    </IconButton>
  );
};

export default ElementLink;
